// extracted by mini-css-extract-plugin
export default {"errorPage":"errorPage---AQd7j","errorMessageLabel":"errorMessageLabel---SHS5C","errorComponent":"errorComponent---NMfJF"};